const SalesChart = () => {
  const data = [
    { day: 'Lun', sales: 4200 },
    { day: 'Mar', sales: 5200 },
    { day: 'Mer', sales: 3800 },
    { day: 'Jeu', sales: 6100 },
    { day: 'Ven', sales: 7200 },
    { day: 'Sam', sales: 8900 },
    { day: 'Dim', sales: 6500 },
  ]

  const maxSales = Math.max(...data.map(d => d.sales))

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="text-sm text-gray-600">Chiffre d'affaires total</p>
          <p className="text-2xl font-bold text-gray-900">€45,200</p>
        </div>
        <div className="text-sm text-success-600 font-medium">
          +12.5% vs semaine dernière
        </div>
      </div>

      <div className="flex items-end justify-between h-48">
        {data.map((item, index) => {
          const height = (item.sales / maxSales) * 100
          return (
            <div key={index} className="flex flex-col items-center flex-1">
              <div className="text-xs text-gray-500 mb-2">{item.day}</div>
              <div className="relative w-8">
                <div
                  className="w-8 bg-primary-500 rounded-t-lg transition-all hover:bg-primary-600"
                  style={{ height: `${height}%` }}
                />
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                  €{item.sales.toLocaleString()}
                </div>
              </div>
            </div>
          )
        })}
      </div>

      <div className="flex items-center justify-between mt-6 pt-6 border-t border-gray-200">
        <div className="flex items-center">
          <div className="h-3 w-3 rounded-full bg-primary-500 mr-2"></div>
          <span className="text-sm text-gray-600">Ventes cette semaine</span>
        </div>
        <div className="flex items-center">
          <div className="h-3 w-3 rounded-full bg-gray-300 mr-2"></div>
          <span className="text-sm text-gray-600">Semaine dernière</span>
        </div>
      </div>
    </div>
  )
}

export default SalesChart
